// types user spanish
export const namesTypesTraduc = [
  {
    code: "ORG-STAFF",
    name: "Colaborador",
  },
  {
    code: "DERIV-USER",
    name: "Derivado",
  },
  {
    code: "ORG-ADMIN",
    name: "Administrador",
  },
  {
    code: "AUTOLOGIN-USER",
    name: "ORGANIZATION AUTOLOGIN USER ACCOUNT",
  },
]

export const appRoles = [
  {
    label: "Administrador Estudio",
    value: "ME.FirmAdmin",
  },
  {
    label: "Colaborador de Estudio",
    value: "ME.FirmStaff",
  },
  // {
  //   label: 'Cliente de Estudio',
  //   value: 'ME.FirmCustomerStaff'
  // }
]

// commercial user types
export const commercialTypesTraduc = [
  {
    code: "SUBSCRIBER",
    name: "Suscriptor",
  },
  {
    code: "REGISTER",
    name: "Registrado",
  },
]

// types organizations spanish
export const traducNameTemporal = (type) => {
  switch (type) {
    case "MAIN-ORG":
      return "Organización Principal"

    case "TESTING-ORG":
      return "Organización de Testeo"

    case "CUSTOMER-ORG":
      return "Organización Cliente"

    default:
      return null
  }
}

export const traducUserStatus = (status) => {
  switch (status) {
    case "ACTIVE":
      return "Activo"
    case "WAITING_VALIDATION":
      return "Esperando validación"
    case "BLOCKED":
      return "Bloqueado"
    case "INACTIVE":
      return "Inactivo"
    default:
      return null
  }
}

// types users status in spanish
// export const traducUserStatus = [
//   { code: 'ACTIVE', name: 'Activo' },
//   { code: 'WAITING_VALIDATION', name: 'Esperando validación' },
//   { code: 'BLOCKED', name: 'Bloqueado' },
//   { code: 'INACTIVE', name: 'Inactivo' }
// ]

export const featureFlagsAppCodes = ["ME"]
export const featureFlagsAppPlatformCodes = [
  {
    value: "MOBILE-ANDROID",
    title: "Versiones para dispositivos con sistema Android",
  },
  { value: "MOBILE-IOS", title: "Versiones para dispositivos con sistema IOS" },
]

export const globalNotificationTypes = [
  { code: "ALERT", title: "Mantenimiento" },
  { code: "ONBOARDING", title: "Onboarding" },
  { code: "INFORMATION", title: "Información" },
]

export const initializeAppInstanceModules = [
  "OrgFirmMgmnt",
  "FirmCustomer",
  "MyCalendar",
  "AlicuotaMgmnt",
  "EconomicIndexes",
  "InstantMessage",
  "TaskMgmnt",
  "Storage",
]
